// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const TooManyReactionsModal = observer(() => {
	const {t} = useLingui();
	return (
		<ConfirmModal
			title={t`Whoa, this is heavy`}
			description={t`This is one heavy message. Some reactions need to be removed before you can add more.`}
			primaryText={t`Understood`}
			onPrimary={() => {}}
			secondaryText={false}
			hideCloseButton
		/>
	);
});
